module.exports = __webpack_public_path__ + "img/page-ico.00e3a996.png";